import {
  ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_REQUEST,
  ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_SUCCESS,
  ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_FAILURE,
  ACCOUNT_ADD_NEW_USER_FAILURE,
  ACCOUNT_ADD_NEW_USER_REQUEST,
  ACCOUNT_ADD_NEW_USER_SUCCESS,
  ACCOUNT_DELETE_DELIVERY_ADDRESS_FAILURE,
  ACCOUNT_DELETE_DELIVERY_ADDRESS_REQUEST,
  ACCOUNT_DELETE_DELIVERY_ADDRESS_SUCCESS,
  ACCOUNT_GET_DELIVERY_ADDRESS_LIST_FAILURE,
  ACCOUNT_GET_DELIVERY_ADDRESS_LIST_REQUEST,
  ACCOUNT_GET_DELIVERY_ADDRESS_LIST_SUCCESS,
  ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_FAILURE,
  ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_REQUEST,
  ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_SUCCESS,
  ACCOUNT_GET_USER_DETAILS_FAILURE,
  ACCOUNT_GET_USER_DETAILS_REQUEST,
  ACCOUNT_GET_USER_DETAILS_SUCCESS,
  ACCOUNT_UPDATE_CHANGE_USER_FAILURE,
  ACCOUNT_UPDATE_CHANGE_USER_REQUEST,
  ACCOUNT_UPDATE_CHANGE_USER_SUCCESS,
  RESET_DELETE_SUCCESS_MESSAGE,
  ACCOUNT_TRANSACTION_HISTORY_REQUEST,
  ACCOUNT_TRANSACTION_HISTORY_FAILURE,
  ACCOUNT_TRANSACTION_HISTORY_SUCCESS,
  ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_FAILURE,
  ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_REQUEST,
  ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_SUCCESS,
  ACCOUNT_TABS_STATUS_SUCCESS,
  ACCOUNT_TABS_STATUS_FAILURE,
  ACCOUNT_TABS_STATUS_REQUEST,
  ACCOUNT_TRANSACTION_HISTORY_CANCEL_FAILURE,
  ACCOUNT_TRANSACTION_HISTORY_CANCEL_REQUEST,
  ACCOUNT_TRANSACTION_HISTORY_CANCEL_SUCCESS,
  ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_FAILURE,
  ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_REQUEST,
  ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_SUCCESS,
  ACCOUNT_BILLING_ACCOUNT_GET_LIST_SUCCESS,
  ACCOUNT_BILLING_ACCOUNT_GET_LIST_REQUEST,
  ACCOUNT_BILLING_ACCOUNT_GET_LIST_FAILURE,
  ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_FAILURE,
  ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_REQUEST,
  ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_SUCCESS,
  SELECT_BILLING_ACCOUNT_DETAIL_NUMBER,
  ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_FAILURE,
  ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_REQUEST,
  ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_SUCCESS,
  BILLING_ACCOUNT_UPDATE_CREDIT_CARD_SUCCESS,
  BILLING_ACCOUNT_UPDATE_CREDIT_CARD_FAILURE,
  BILLING_ACCOUNT_UPDATE_CREDIT_CARD_REQUEST,
  ACCOUNT_TRANSACTION_HISTORY_DETAILS_FAILURE,
  ACCOUNT_TRANSACTION_HISTORY_DETAILS_REQUEST,
  ACCOUNT_TRANSACTION_HISTORY_DETAILS_SUCCESS,
  ACCOUNT_UPLOAD_DOCUMENTS_REQUEST,
  ACCOUNT_UPLOAD_DOCUMENTS_SUCCESS,
  ACCOUNT_UPLOAD_DOCUMENTS_FAILURE,
  ACCOUNT_DELETE_POLICY_FAILURE,
  ACCOUNT_DELETE_POLICY_REQUEST,
  ACCOUNT_DELETE_POLICY_SUCCESS,
  ACCOUNT_DOWNLOAD_DOCUMENT_FAILURE,
  ACCOUNT_DOWNLOAD_DOCUMENT_REQUEST,
  ACCOUNT_DOWNLOAD_DOCUMENT_SUCCESS,
  ACCOUNT_GET_ACCOUNT_PAGE_FAILURE,
  ACCOUNT_GET_ACCOUNT_PAGE_REQUEST,
  ACCOUNT_GET_ACCOUNT_PAGE_SUCCESS,
  ACCOUNT_GET_POLICY_DETAILS_FAILURE,
  ACCOUNT_GET_POLICY_DETAILS_REQUEST,
  ACCOUNT_GET_POLICY_DETAILS_SUCCESS,
  ACCOUNT_GET_POLICY_LSIT_FAILURE,
  ACCOUNT_GET_POLICY_LSIT_REQUEST,
  ACCOUNT_GET_POLICY_LSIT_SUCCESS,
  ACCOUNT_GET_POLICY_TEMPLATE_FAILURE,
  ACCOUNT_GET_POLICY_TEMPLATE_REQUEST,
  ACCOUNT_GET_POLICY_TEMPLATE_SUCCESS,
  ACCOUNT_SAVE_POLICY_FAILURE,
  ACCOUNT_SAVE_POLICY_REQUEST,
  ACCOUNT_SAVE_POLICY_SUCCESS,
  ACCOUNT_DELETE_DOCUMENT_FAILURE,
  ACCOUNT_DELETE_DOCUMENT_REQUEST,
  ACCOUNT_DELETE_DOCUMENT_SUCCESS,
  ACCOUNT_GET_PROFILE_FAILURE,
  ACCOUNT_GET_PROFILE_REQUEST,
  ACCOUNT_GET_PROFILE_SUCCESS,
  ACCOUNT_GET_PROFILE_WITHOUTDOC_FAILURE,
  ACCOUNT_GET_PROFILE_WITHOUTDOC_REQUEST,
  ACCOUNT_GET_PROFILE_WITHOUTDOC_SUCCESS,
  ACCOUNT_UPDATE_PROFILE_FAILURE,
  ACCOUNT_UPDATE_PROFILE_REQUEST,
  ACCOUNT_UPDATE_PROFILE_SUCCESS,
  CHANGE_BILLING_ADDRESS_REQUEST,
  CHANGE_BILLING_ADDRESS_SUCCESS,
  CHANGE_BILLING_ADDRESS_FAILURE,
  CHANGE_BILLING_ADDRESS_RESET,
  ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_FAILURE,
  ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_REQUEST,
  ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_SUCCESS,
  ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_REQUEST,
  ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_SUCCESS,
  ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_FAILURE,
  ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_REQUEST,
  ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_SUCCESS,
  ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_FAILURE,
  ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_REQUEST,
  ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_FAILURE,
  ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_SUCCESS
} from './actionTypes';
import {
  AccountAddNewUserRequestFailure,
  AccountGetAccountPageRequest,
  AccountGetAccountPageRequestFailure,
  AccountGetAccountPageRequestSuccess,
  AccountGetAddNewUserRequest,
  AccountUpdateChangeUserRequest,
  ISpocApproval
} from './models/types';
import {
  GetDeliveryAddressRequest,
  GetDeliveryAddressSuccess,
  GetDeliveryAddressFailure,
  SaveDeliveryAddressListRequest,
  SaveDeliveryAddressListSuccess,
  SaveDeliveryAddressListFailure,
  DeleteDeliveryAddressRequest,
  DeleteDeliveryAddressSuccess,
  DeleteDeliveryAddressFailure,
  IEnrollmentStatus,
  IBillingAddress,
  ICreditCardUpdate,
  GetResidentialAddressFailure,
  GetResidentialAddressRequest,
  GetResidentialAddressSuccess,
  EditDeliveryAddressListFailure,
  EditDeliveryAddressListRequest,
  EditDeliveryAddressListSuccess
} from './types';

export const getProfile = {
  request: () => ({ type: ACCOUNT_GET_PROFILE_REQUEST }),
  success: (data) => ({ type: ACCOUNT_GET_PROFILE_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_GET_PROFILE_FAILURE, error })
};

export const getProfileWithoutDoc = {
  request: () => ({ type: ACCOUNT_GET_PROFILE_WITHOUTDOC_REQUEST }),
  success: (data) => ({ type: ACCOUNT_GET_PROFILE_WITHOUTDOC_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_GET_PROFILE_WITHOUTDOC_FAILURE, error })
};

export const updateProfile = {
  request: (profileInfo) => ({
    type: ACCOUNT_UPDATE_PROFILE_REQUEST,
    profileInfo
  }),
  success: (data) => ({ type: ACCOUNT_UPDATE_PROFILE_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_UPDATE_PROFILE_FAILURE, error })
};

export const uploadDocuments = {
  request: (newFiles, documentName, callback: (uploadedDocumentsId) => void = () => null) => ({
    type: ACCOUNT_UPLOAD_DOCUMENTS_REQUEST,
    newFiles,
    documentName,
    callback
  }),
  success: () => ({ type: ACCOUNT_UPLOAD_DOCUMENTS_SUCCESS }),
  failure: (error) => ({ type: ACCOUNT_UPLOAD_DOCUMENTS_FAILURE, error })
};

export const deleteDocument = {
  request: (deleteId, callback: () => void = () => null) => ({
    type: ACCOUNT_DELETE_DOCUMENT_REQUEST,
    deleteId,
    callback
  }),
  success: (data) => ({ type: ACCOUNT_DELETE_DOCUMENT_SUCCESS, data }),
  failure: () => ({ type: ACCOUNT_DELETE_DOCUMENT_FAILURE })
};

export const downloadDocument = {
  request: (documentId, callback: React.ReactNode | null = () => null) => ({
    type: ACCOUNT_DOWNLOAD_DOCUMENT_REQUEST,
    documentId,
    callback
  }),
  success: (data) => ({ type: ACCOUNT_DOWNLOAD_DOCUMENT_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_DOWNLOAD_DOCUMENT_FAILURE, error })
};

export const getAccountPage = {
  request: (gridOptions): AccountGetAccountPageRequest => ({
    type: ACCOUNT_GET_ACCOUNT_PAGE_REQUEST,
    gridOptions
  }),
  success: (data): AccountGetAccountPageRequestSuccess => ({
    type: ACCOUNT_GET_ACCOUNT_PAGE_SUCCESS,
    data
  }),
  failure: (error): AccountGetAccountPageRequestFailure => ({
    type: ACCOUNT_GET_ACCOUNT_PAGE_FAILURE,
    error
  })
};

export const getPolicyList = {
  request: (payload) => ({
    type: ACCOUNT_GET_POLICY_LSIT_REQUEST,
    payload
  }),
  success: (data) => ({ type: ACCOUNT_GET_POLICY_LSIT_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_GET_POLICY_LSIT_FAILURE, error })
};

export const getPolicyTemplate = {
  request: () => ({ type: ACCOUNT_GET_POLICY_TEMPLATE_REQUEST }),
  success: (data) => ({ type: ACCOUNT_GET_POLICY_TEMPLATE_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_GET_POLICY_TEMPLATE_FAILURE, error })
};

export const getPolicyDetails = {
  request: (options = {}) => ({
    type: ACCOUNT_GET_POLICY_DETAILS_REQUEST,
    options
  }),
  success: (data) => ({ type: ACCOUNT_GET_POLICY_DETAILS_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_GET_POLICY_DETAILS_FAILURE, error })
};

export const savePolicy = {
  request: (policy) => ({
    type: ACCOUNT_SAVE_POLICY_REQUEST,
    policy
  }),
  success: (data) => ({ type: ACCOUNT_SAVE_POLICY_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_SAVE_POLICY_FAILURE, error })
};

export const deletePolicy = {
  request: (policyId) => ({
    type: ACCOUNT_DELETE_POLICY_REQUEST,
    policyId
  }),
  success: (data) => ({ type: ACCOUNT_DELETE_POLICY_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_DELETE_POLICY_FAILURE, error })
};

export const getTabConfigType = {
  request: () => ({ type: ACCOUNT_TABS_STATUS_REQUEST }),
  success: (data) => ({ type: ACCOUNT_TABS_STATUS_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_TABS_STATUS_FAILURE, error })
};

export const getAllOrderTranHistory = {
  request: (page, size, orderNo, status, sortDir = 'DESC') => ({
    type: ACCOUNT_TRANSACTION_HISTORY_REQUEST,
    page,
    size,
    orderNo,
    status,
    sortDir
  }),
  success: (data) => ({ type: ACCOUNT_TRANSACTION_HISTORY_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_TRANSACTION_HISTORY_FAILURE, error })
};

export const getTransactionHistoryDetail = {
  request: (ordNo: string) => ({
    type: ACCOUNT_TRANSACTION_HISTORY_DETAILS_REQUEST,
    ordNo
  }),
  success: (data) => ({ type: ACCOUNT_TRANSACTION_HISTORY_DETAILS_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_TRANSACTION_HISTORY_DETAILS_FAILURE, error })
};

export const getSpocApprovalStatusTranHistory = {
  request: (reqData: ISpocApproval) => ({
    type: ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_REQUEST,
    reqData
  }),
  success: (data) => ({ type: ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_FAILURE, error })
};

export const getCancelTransOrder = {
  request: (orderNo: string) => ({
    type: ACCOUNT_TRANSACTION_HISTORY_CANCEL_REQUEST,
    orderNo
  }),
  success: (data) => ({ type: ACCOUNT_TRANSACTION_HISTORY_CANCEL_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_TRANSACTION_HISTORY_CANCEL_FAILURE, error })
};

export const updateDeliveryDateDetails = {
  request: (reqData) => ({
    type: ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_REQUEST,
    reqData
  }),
  success: (data) => ({ type: ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_FAILURE, error })
};

export const getAllUserDetails = {
  request: (brn, page, size, searchRequest) => ({
    brn,
    page,
    size,
    searchRequest,
    type: ACCOUNT_GET_USER_DETAILS_REQUEST
  }),
  success: (data) => ({ type: ACCOUNT_GET_USER_DETAILS_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_GET_USER_DETAILS_FAILURE, error })
};

export const addNewUserDetails = {
  request: (reqData): AccountGetAddNewUserRequest => ({
    type: ACCOUNT_ADD_NEW_USER_REQUEST,
    reqData
  }),
  success: (data) => ({ type: ACCOUNT_ADD_NEW_USER_SUCCESS, data }),
  failure: (error): AccountAddNewUserRequestFailure => ({ type: ACCOUNT_ADD_NEW_USER_FAILURE, error })
};

export const updateChangeUserDetails = {
  request: (updateInfo): AccountUpdateChangeUserRequest => ({
    type: ACCOUNT_UPDATE_CHANGE_USER_REQUEST,
    updateInfo
  }),
  success: (data) => ({ type: ACCOUNT_UPDATE_CHANGE_USER_SUCCESS, data }),
  failure: (error): AccountAddNewUserRequestFailure => ({ type: ACCOUNT_UPDATE_CHANGE_USER_FAILURE, error })
};

export const getDeliveryAddressesList = {
  request: (brn): GetDeliveryAddressRequest => ({
    type: ACCOUNT_GET_DELIVERY_ADDRESS_LIST_REQUEST,
    brn
  }),
  success: (data): GetDeliveryAddressSuccess => ({ type: ACCOUNT_GET_DELIVERY_ADDRESS_LIST_SUCCESS, data }),
  failure: (error): GetDeliveryAddressFailure => ({ type: ACCOUNT_GET_DELIVERY_ADDRESS_LIST_FAILURE, error })
};

export const getResidentialAddressesList = {
  request: (brn): GetResidentialAddressRequest => ({
    type: ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_REQUEST,
    brn
  }),
  success: (data): GetResidentialAddressSuccess => ({ type: ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_SUCCESS, data }),
  failure: (error): GetResidentialAddressFailure => ({ type: ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_FAILURE, error })
};

export const saveDeliveryAddressesList = {
  request: (payload): SaveDeliveryAddressListRequest => ({
    type: ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_REQUEST,
    payload
  }),
  success: (data): SaveDeliveryAddressListSuccess => ({ type: ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_SUCCESS, data }),
  failure: (error): SaveDeliveryAddressListFailure => ({ type: ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_FAILURE, error })
};

export const editDeliveryAddressesList = {
  request: (payload): EditDeliveryAddressListRequest => ({
    type: ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_REQUEST,
    payload
  }),
  success: (data): EditDeliveryAddressListSuccess => ({ type: ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_SUCCESS, data }),
  failure: (error): EditDeliveryAddressListFailure => ({ type: ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_FAILURE, error })
};

export const deleteDeliveryAddresses = {
  request: (payload): DeleteDeliveryAddressRequest => ({
    type: ACCOUNT_DELETE_DELIVERY_ADDRESS_REQUEST,
    payload
  }),
  success: (data): DeleteDeliveryAddressSuccess => ({ type: ACCOUNT_DELETE_DELIVERY_ADDRESS_SUCCESS, data }),
  failure: (error): DeleteDeliveryAddressFailure => ({ type: ACCOUNT_DELETE_DELIVERY_ADDRESS_FAILURE, error })
};

export const resetDeleteAddressSuccessMsg = (message: string) => ({
  type: RESET_DELETE_SUCCESS_MESSAGE,
  message
});

export const getBillingAccountList = {
  request: (brn, page, size, searchParam = '') => ({
    type: ACCOUNT_BILLING_ACCOUNT_GET_LIST_REQUEST,
    brn,
    page,
    size,
    searchParam
  }),
  success: (data) => ({ type: ACCOUNT_BILLING_ACCOUNT_GET_LIST_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_BILLING_ACCOUNT_GET_LIST_FAILURE, error })
};

export const getBillingAccountEnrollmentStatus = {
  request: (reqData: IEnrollmentStatus) => ({ type: ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_REQUEST, reqData }),
  success: (data) => ({ type: ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_FAILURE, error })
};

export const getServiceNumbersByBillingAccount = {
  request: (reqData: IEnrollmentStatus) => ({ type: ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_REQUEST, reqData }),
  success: (data) => ({ type: ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_FAILURE, error })
};

export const selectBillingId = (billingaddress: IBillingAddress) => ({
  type: SELECT_BILLING_ACCOUNT_DETAIL_NUMBER,
  billingaddress
});

export const updateCreditCardByBillingAccount = {
  request: (reqData: ICreditCardUpdate) => ({ type: BILLING_ACCOUNT_UPDATE_CREDIT_CARD_REQUEST, reqData }),
  success: (data) => ({ type: BILLING_ACCOUNT_UPDATE_CREDIT_CARD_SUCCESS, data }),
  failure: (error) => ({ type: BILLING_ACCOUNT_UPDATE_CREDIT_CARD_FAILURE, error })
};

export const changeBillingAddress = {
  request: (reqData) => ({ type: CHANGE_BILLING_ADDRESS_REQUEST, reqData }),
  success: (data) => ({ type: CHANGE_BILLING_ADDRESS_SUCCESS, data }),
  failure: (error) => ({ type: CHANGE_BILLING_ADDRESS_FAILURE, error }),
  reset: () => ({ type: CHANGE_BILLING_ADDRESS_RESET })
};

export const uploadNumberPortDocuments = {
  request: (newFiles, documentName, callback: React.ReactNode | null = () => null) => ({
    type: ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_REQUEST,
    newFiles,
    documentName,
    callback
  }),
  success: () => ({ type: ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_SUCCESS }),
  failure: (error) => ({ type: ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_FAILURE, error })
};

export const downloadDocumentNumberPort = {
  request: (documentId, callback: React.ReactNode | null = () => null) => ({
    type: ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_REQUEST,
    documentId,
    callback
  }),
  success: (data) => ({ type: ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_FAILURE, error })
};

export const deleteDocumentNumberPort = {
  request: (deleteId, callback: () => void = () => null) => ({
    type: ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_REQUEST,
    deleteId,
    callback
  }),
  success: (data) => ({ type: ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_SUCCESS, data }),
  failure: (error) => ({ type: ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_FAILURE, error })
};
